import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './style.scss';
import success from '../../assets/img/success.png';
const UsePayResult = () => {
  const navigate = useNavigate();
  const [showPayResult, setShowPayResult] = useState(false);
  useEffect(() => {
    let pre_pay_url = localStorage.getItem('pre_pay_url');
    (window as any).openWebPage(pre_pay_url);
    setTimeout(() => {
      setShowPayResult(true);
    }, 1000);
  }, []);

  return (
    <div className='pay-result'>
      <div
        className={showPayResult ? 'pop-tip' : 'pop-tip pop-tip-hide'}
        onClick={(e) => {
          setShowPayResult(false);
        }}>
        <div
          className='pop-tip-main'
          onClick={(e) => {
            e.stopPropagation();
          }}>
          <div className='success-box'>
            <img className='success-icon' src={success} alt='' />
          </div>
          <p className='title'>支付结果是否成功?</p>
          <div className='pip-btn-box'>
            <button
              type='button'
              style={{ color: '#888' }}
              onClick={() =>
                navigate(`/?${localStorage.getItem('url_search')}`)
              }>
              回到充值页面
            </button>
            <button
              type='button'
              style={{ color: '#74d0c1' }}
              onClick={() => navigate('/orderlist')}>
              我已支付
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UsePayResult;
